import React from 'react';
import Image150 from './../../images/images-master/images-personal-svg/foto-150.svg'
import TitleAlt from './../../atoms/TitleAlt.jsx'

const Presentation = () => (
    <section className="container-information">
        <article className="image-information">
            <img src={Image150} alt={TitleAlt} />
        </article>

        <article className="container-letter">
            <p>César Eliud Rodriguez Añorve</p>
            <p>eliud10rgan@gmail.com</p>
            <p>Ometepec, Guerrero</p>
            <p>741-110-1023</p>
        </article>
    </section>
)

export default Presentation;
